.atm_9s_1ulexfb{display:block;}
.atm_9j_13gfvf7{cursor:not-allowed;}
.atm_vy_1osqo2v{width:100%;}
